exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#uislag[data-v-276d9de3] {\n    text-align: left;\n}\n\n", ""]);

// exports
